import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'kentimata';
const args = {};

export class Kentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
